<script setup lang="ts">
import rules from 'loans/services/rules'

defineProps<{
  content: any
}>()

const values = ref<any>({})
const store = useFormStore()
async function submit(submitValues: any) {
  Object.assign(store.values, { ...submitValues })
  await store.updateDemand(false, false)
}
</script>

<template>
  <FormStep v-model="values" :submit="submit">
    <template #active>
      <div class="flex flex-col gap-5 p-5">
        <h2>{{ content.paymentHeader }}</h2>
        <div>{{ content.paymentText }}</div>
        <FormFieldDropdown
          name="incomeType"
        />
        <FormFieldText
          name="netIncome"
          :mask="{ mask: Number, thousandsSeparator: ' ' }"
          suffix="Kč"
          :rules="rules.netIncome"
        />
        <FormFieldText
          name="monthlyExpenses"
          :mask="{ mask: Number, thousandsSeparator: ' ' }"
          suffix="Kč"
          :rules="rules.monthlyExpenses"
        />
        <FormFieldText
          name="monthlyInstallments"
          :mask="{ mask: Number, thousandsSeparator: ' ' }"
          suffix="Kč"
        />
        <FormFieldSlider
          name="numberOfDependents"
        />
        <FormFieldDropdown
          name="housingType"
        />
        <FormFieldSlider
          name="numberOfHouseholdMembers"
        />
        <BaseButton :text="content.defaultButtonText" :loading="store.loading" block submit />
      </div>
    </template>
    <template #incomplete>
      <div class="bg-gray bg-opacity-15 p-5 text-lg text-gray-dark font-bold">
        {{ content.paymentHeader }}
      </div>
    </template>

    <template #complete="{ editStep, mappedValues }">
      <div class="flex flex-col gap-3 bg-gray-300 bg-opacity-20 px-5 py-10">
        <div class="flex justify-between items-center gap-3">
          <span class="text-success">
            <AppIcon
              icon="fal-check-circle"
              size="30"
            />
          </span>
          <div class="font-bold text-lg flex-grow">
            <span>{{ content.paymentHeader }}</span>
          </div>
          <div class="flex text-primary items-center cursor-pointer" @click="editStep">
            <AppIcon
              icon="far-pencil"
              size="16"
            />
            <span class="ml-1">Upravit</span>
          </div>
        </div>
        <div class="flex flex-col flex-grow gap-1 text-gray-dark">
          <div class="flex justify-between items-center">
            <span class="whitespace-nowrap">{{ content.paymentSummaryIncomeType }}</span>
            <span class="font-medium text-right">{{ mappedValues.incomeType }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span>{{ content.paymentSummaryNetIncome }}</span>
            <span class="font-medium">{{ values.netIncome.toLocaleString() }} Kč</span>
          </div>
          <div class="flex justify-between items-center">
            <span>{{ content.paymentSummaryMonthlyExpenses }}</span>
            <span class="font-medium">{{ values.monthlyExpenses.toLocaleString() }} Kč</span>
          </div>
          <div class="flex justify-between items-center">
            <span>{{ content.paymentSummaryMonthlyInstallments }}</span>
            <span class="font-medium">{{ values.monthlyInstallments.toLocaleString() }} Kč</span>
          </div>
          <div class="flex justify-between items-center">
            <span>{{ content.paymentSummaryNumberOfDependents }}</span>
            <span class="font-medium">{{ values.numberOfDependents }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span>{{ content.paymentSummaryHousingType }}</span>
            <span class="font-medium">{{ mappedValues.housingType }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span>{{ content.paymentSummaryNumberOfHouseholdMembers }}</span>
            <span class="font-medium">{{ values.numberOfHouseholdMembers }}</span>
          </div>
        </div>
      </div>
    </template>
  </FormStep>
</template>
